<template>
  <!--
    Rendu d'une option de dropdown ( ListFilter / ReferenceFilter ) avec
    tooltip natif HTML ( attribut {@code title} ) . Choix de simplicité
    après essai d'un tooltip Buefy stylé : le natif est suffisant pour
    le besoin , 100% accessible , aucune dépendance , aucun z-index à
    gérer , aucun conflit possible avec le panneau dropdown téléporté
    de b-taginput / b-autocomplete .

    <p><b>Pourquoi un composant dédié</b> ( malgré la simplicité du
    rendu ) :
    <ul>
      <li><b>DRY</b> : mutualisation entre ListFilter et ReferenceFilter
          ( libellé tooltip + html highlight + ellipsis CSS unique ) ;</li>
      <li><b>OCP</b> : si on rebranchait un jour un tooltip stylé Buefy
          ou un popover custom , il n'y aurait qu'un seul point de
          modification ;</li>
      <li><b>SRP</b> : le calcul du libellé brut ( i18n , empty sentinel )
          et du HTML highlighté reste à la charge du parent .</li>
    </ul>
  -->
  <span
    class="oa-list-option-tooltip__text"
    :title="tooltipLabel"
    :aria-label="tooltipLabel"
    v-html="displayHtml || tooltipLabel"
  />
</template>

<script lang="ts">
export default {
  name: "OaListOptionTooltip",
  props: {
    /** Texte complet brut affiché dans le tooltip natif . */
    tooltipLabel: {
      type: String,
      required: true,
    },
    /**
     * HTML pré-calculé pour le rendu de l'option ( ex sortie de
     * {@code highlightMatch} avec balises {@code <mark>} ) . Si vide ,
     * on retombe sur {@link tooltipLabel} en texte simple .
     */
    displayHtml: {
      type: String,
      required: false,
      default: "",
    },
  },
};
</script>

<style scoped>
.oa-list-option-tooltip__text {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
